import { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";

/**
 * ScrollToTop Button
 * Appears after scrolling down a certain distance and scrolls smoothly to the top.
 */
const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    handleScroll(); // Initial check
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    isVisible && (
      <button
        onClick={scrollToTop}
        className="fixed z-50 right-4 bottom-20 md:right-6 md:bottom-28 bg-cyan-600 hover:bg-cyan-700 text-white rounded-full shadow-lg p-3 md:p-4 transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-opacity-50"
        aria-label="Scroll to top"
      >
        <FaArrowUp className="h-5 w-5 md:h-6 md:w-6" />
      </button>
    )
  );
};

export default ScrollToTop;
